export { default } from './QuoteResultSection';
export type {
  QuoteResultProps,
  QuoteResultSectionProps
} from './QuoteResultSection';
